import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prg-select-condition',
  templateUrl: './select-condition.component.html',
  styleUrls: ['./select-condition.component.css']
})
export class SelectConditionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/select-condition/select-condition.component.ts